var imageSliders = document.querySelectorAll('.image-swiper');

var initImageSlider = (item) => {
  var options = {
    navigation: {
      nextEl: item.parentElement.parentElement.parentElement.querySelector('.image-swiper-nav__next'),
      prevEl: item.parentElement.parentElement.parentElement.querySelector('.image-swiper-nav__prev'),
    },
    loop: true,
    iOSEdgeSwipeDetection: true,
    iOSEdgeSwipeThreshold: 0,
    simulateTouch: true,
    preventInteractionOnTransition: true,
    speed: 500,
    height: 'auto',
    initialSlide: 1,
    spaceBetween: 30,
    slidesPerView: 'auto',
  };
  var imageSlider = new Swiper(item, options);
};

imageSliders.forEach((item, i) => {
  let slider = false;
  function initSwiper() {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 992 && slider) {
      slider.destroy(true, true);
      slider = false;
    } else if (screenWidth > 992 && !slider) {
      slider = initImageSlider(item);
    }
  }

  initSwiper();
  window.addEventListener('resize', initSwiper);
});
